import { useState } from "react";
import { Menu, X, Heart, Phone, CalendarCheck } from "lucide-react";
import { Link } from "react-router-dom";
import BrandLogo from "@/components/landing/BrandLogo";
import MobileMenu from "@/components/landing/MobileMenu";
import { businessConfig } from "@/config";

const RUNNING_WILD_LOGO =
  "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/bbbqebql_1.png";
const RUNNING_WILD_URL = "https://runningwildrescue.ca";

const NAV_LINKS = [
  { href: "#services", label: "Our Services" },
  { href: "#visit", label: "Visit Us" },
];

export default function LandingHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="landing-header" data-testid="landing-header">
      <div className="landing-header__inner">
        <a href="#top" className="landing-header__brand" data-testid="landing-logo-link">
          <BrandLogo size={44} iconSize={20} className="landing-header__logo" />
          <span className="landing-header__brand-text">
            <span className="landing-header__brand-name">{businessConfig.name}</span>
            <span className="landing-header__brand-overline">MOOSE JAW · EST. 2018</span>
          </span>
        </a>

        <a
          href={RUNNING_WILD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="landing-header__donate landing-header__donate--default"
          data-testid="header-donate-cta"
          aria-label="Donate to Running Wild Rescue"
        >
          <span className="landing-header__donate-thumb">
            <img src={RUNNING_WILD_LOGO} alt="" loading="lazy" />
          </span>
          <span className="landing-header__donate-label">
            <Heart className="w-3.5 h-3.5" strokeWidth={2.4} />
            Donate to Running Wild Rescue
          </span>
        </a>

        <nav className="landing-header__nav landing-header__nav--right" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="landing-header__link"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
          <a href="tel:3066910001" className="landing-header__compact-call">
            <Phone className="w-4 h-4" />
            Call
          </a>
          <Link to="/book" className="landing-header__compact-book">
            <CalendarCheck className="w-4 h-4" />
            Book
          </Link>
        </nav>

        <button
          type="button"
          className="landing-header__hamburger"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {menuOpen ? (
        <MobileMenu navLinks={NAV_LINKS} onClose={() => setMenuOpen(false)} />
      ) : null}
    </header>
  );
}
